import { render, staticRenderFns } from "./PortrayalInfo.vue?vue&type=template&id=2733f510&"
import script from "./PortrayalInfo.ts?vue&type=script&lang=ts&"
export * from "./PortrayalInfo.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports